
import './App.css';
import NavbarComponent from './components/Navbar';

function App() {
  return (
    <div className="App">
      <NavbarComponent />
    </div>
  );
}

export default App;
